import actionTypes from "../constants/actionTypes";
import {getStatsItems} from "../../../../services/accounting/stats";

export const getStatsItemsAction = (from, to, page, pageSize) => async (dispatch) => {
    const { STATS_ITEMS_FETCH, STATS_ITEMS_SUCCESS, STATS_ITEMS_ERROR } = actionTypes;
    dispatch({ type: STATS_ITEMS_FETCH });
    try {
        const payload = await getStatsItems(from, to, page, pageSize);
        dispatch({ type: STATS_ITEMS_SUCCESS, payload: payload });
    } catch (error) {
        const errorResponse = error.response;
        dispatch({ type: STATS_ITEMS_ERROR, error: errorResponse });
    }
};
